import * as React from 'react';
import { cn } from '@/lib/utils';

type StatusVariant = 'active' | 'inactive' | 'draft' | 'pending' | 'unlisted' | 'listed';

const variantStyles: Record<StatusVariant, string> = {
  active: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  inactive: 'bg-red-500/10 text-red-400 border-red-500/20',
  draft: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
  pending: 'bg-orange-500/10 text-orange-400 border-orange-500/20',
  unlisted: 'bg-zinc-500/10 text-zinc-400 border-zinc-500/20',
  listed: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
};

interface StatusBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant: StatusVariant;
}

export function StatusBadge({ variant, className, children, ...props }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium',
        variantStyles[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
